// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"400":"c4337d89","842":"b6aeaf03"}[chunkId] + ".chunk.js";
};